import { RsNetwork, PagingReq, ResCode, PagingResData, CommonResponse, RsNetworkMeter, SimplifyMeter, NetworkData } from './baseDefine';
import request from '@/utils/request';

export interface AddRsNetworkReq {
    rsNetwork: RsNetwork;
}

export interface BindsNetworkReq {
    rsNetwork: RsNetwork;
}

export interface GetRsNetworksReq extends PagingReq {
    // 0所有  1master  2非master
    masterType: number;
    subMeterID: number;
    rsNetwork: RsNetwork;
}

export interface RsNetworkData {
    code: ResCode;
    msg: string;
    data: RsNetworkRes;
}
export interface RsNetworkRes {
    data: RsNetworkResData
}
export interface RsNetworkResData extends PagingResData {
    rsNetworks: RsNetwork[];
}

export interface UpdateRsNetworkReq {
    rsNetwork: RsNetwork;
}
export interface UpdateRsNetworkMeterReq {
    rsNetworkMeter: RsNetworkMeter;
}
export interface DeleteRsNetworkReq {
    id: number;
}
export interface DeleteRsNetworkMeterReq {
    id: number;
}
export interface GetRsNetworkDatasReq {
    meterID: string
}
export interface SendDataReq {
    meterIDs: SimplifyMeter[];
    params: string;
    dataType: number;
}
export interface SendEventLogRequestReq {
    masterMeterId: string,
    masterMeterTypeID: number;
    meterID: string;
    index: number;
}
export interface GetRsNetworkDatasRes extends CommonResponse {
    data: GetRsNetworkDatasResData;
}
export interface GetRsNetworkDatasResData extends CommonResponse {
    datas: NetworkData[];
}
export function rsNetworks(req: GetRsNetworksReq): Promise<RsNetworkData> {
    return request.post<RsNetworkData>('/api/meter/rsNetworks', req);
}

export function addRsNetwork(req: AddRsNetworkReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/addRsNetwork', req);
}

export function bindRsNetwork(req: BindsNetworkReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/bindRsNetworkMeter', req);
}

export function updateRsNetwork(req: UpdateRsNetworkReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/updateRsNetwork', req);
}

export function updateRsNetworkMeter(req: UpdateRsNetworkMeterReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/updateRsNetworkMeter', req);
}

export function deleteRsNetwork(req: DeleteRsNetworkReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/deleteRsNetwork', req);
}

export function deleteRsNetworkMeter(req: DeleteRsNetworkMeterReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/deleteRsNetworkMeter', req);
}
export function sendRsNetworkData(req: SendDataReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/sendRsNetworkData', req);
}

export function getRsNetworkDatas(req: GetRsNetworkDatasReq): Promise<GetRsNetworkDatasRes> {
    return request.post<GetRsNetworkDatasRes>('/api/meter/getRsNetworkDatas', req);
}

export function sendEventLogRequest(req: SendEventLogRequestReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/sendEventRequest', req);
}